import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "react-md";

import * as StepTypes from "components/Homeowner/CaseStepper/StepTypes";
import { getCaseStatusTracker } from "requests/statusTracker";
import { MStepper, MSpinner } from "components/Shared";

import StatusTrackerIcon from "components/Homeowner/CaseStepper/StepStyles/StatusTracker";

class CaseStepper extends React.Component {
  constructor(props) {
    super(props);
    this.getIconComponent = this.getIconComponent.bind(this);
  }

  componentDidMount() {
    if (!this.props.caseStepper.fetchingCaseStepper) {
      this.props.getCaseStatusTracker(this.props.controlNumber);
    }
  }

  getIconComponent() {
    switch (this.props.stepType) {
      case StepTypes.STATUS_TRACKER:
        return StatusTrackerIcon;
      default:
        return null;
    }
  }

  render() {
    const { caseStepper: { trackerActive, steps, activeStep, fetchingCaseStepper, isClosed }, navigateToCase, openCaseTab } = this.props;

    if (!trackerActive) return null;
    else if (fetchingCaseStepper) return <MSpinner />;

    return (
      <>
        <MStepper
          steps={steps}
          activeStep={activeStep}
          iconComponent={this.getIconComponent()}
          customClass="case-stepper"
        />
        {isClosed &&
          <div className="case-stepper-contact-customer-service">
            <Button
              id="stepper-customer-case-email-button"
              raised
              primary
              onClick={() =>
                navigateToCase
                  ? navigateToCase({ firstTab: "Validation" })
                  : openCaseTab("Validation")}
            >
              Contact Customer Service
            </Button>
          </div>
        }
      </>
    );
  }
}

CaseStepper.propTypes = {
  controlNumber: PropTypes.number,
  stepType: PropTypes.string,
  caseStepper: PropTypes.object,
  getCaseStatusTracker: PropTypes.func,

  navigateToCase: PropTypes.func, // Implies we're viewing the case header outside of the full case, need to open the case with the CS email tab
  openCaseTab: PropTypes.func, // Implies we're viewing the case header on a case, open the CS email tab
};

const mstp = state => {
  return {
    caseStepper: state.caseStepper,
  };
};

const mdtp = dispatch => ({
  getCaseStatusTracker(controlNumber) {
    dispatch(getCaseStatusTracker(controlNumber));
  }
});


export default connect(mstp, mdtp)(CaseStepper);
